import { InvoicesApiClient } from '@melio/platform-api-axios-client';

import { useModel, UseModelProps } from '../../api-client';
import { InvoiceSummaryRawData, PostInvoiceSummaryRawDataRequest } from './types';

// the interface expected by useModelApi needs to have an id property
const postRawSummaryInvoice = (_id: string, args?: PostInvoiceSummaryRawDataRequest) =>
  InvoicesApiClient.postRawSummaryInvoice(args);

export type UseInvoiceSummaryV2Props = Omit<UseModelProps<typeof postRawSummaryInvoice>, 'id'>;

export const useInvoiceSummaryV2 = ({
  params,
  enabled = !!(params?.discount || params?.taxRate || params?.serviceCharges?.length || params?.lineItems?.length),
  ...props
}: UseInvoiceSummaryV2Props = {}) =>
  useModel<typeof postRawSummaryInvoice, never, never, never, InvoiceSummaryRawData>({
    ...props,
    id: 'postRawSummaryInvoice',
    enabled,
    queryKey: 'InvoicesApi',
    queryFn: postRawSummaryInvoice,
    params,
    keepPreviousData: true,
  });

export type InvoiceSummaryModelV2 = ReturnType<typeof useInvoiceSummaryV2>;
